import { Modal, Checkbox, Button } from 'antd';

//const ColumnSelectorModal = ({ visible, columns, selectedColumns, onConfirm, onCancel }) => {
export default (props:any) => {
    const { visible, columns = [], selectedColumns = [], onConfirm, onCancel } = props;

    return (
        <Modal
            title="Descargar planilla con datos"
            open={visible}
            onOk={props.okButton}
            onCancel={onCancel}
        >
            {Array.isArray(columns) ? (
                columns.map((col: any) => (
                    <div key={col.key}>
                        <Checkbox
                            checked={Array.isArray(selectedColumns) ? (selectedColumns.includes(col.key)):(false) }
                            onChange={(e) => {
                                if (e.target.checked) {
                                    onConfirm([...selectedColumns, col.key]);
                                } else {
                                    onConfirm(selectedColumns.filter((key: any) => key !== col.key));
                                }
                            }}
                        >
                            {col.title}
                        </Checkbox>
                    </div>
                ))
            ) : (
                <p>No hay columnas disponibles</p>
            )}
        </Modal>
    );
};